import {
  hapticFeedbackImpactOccurred,
  hapticFeedbackNotificationOccurred,
  hapticFeedbackSelectionChanged,
} from "@telegram-apps/sdk-react";

type ImpactStyle = "light" | "medium" | "heavy" | "rigid" | "soft";
type NotificationType = "error" | "success" | "warning";

export const haptic = {
  impact(style: ImpactStyle = "light") {
    try {
      hapticFeedbackImpactOccurred.ifAvailable(style);
    } catch {
      // Haptics are optional and should never block the action.
    }
  },

  notification(type: NotificationType) {
    try {
      hapticFeedbackNotificationOccurred.ifAvailable(type);
    } catch {
      // Haptics are optional and should never block the action.
    }
  },

  selection() {
    try {
      hapticFeedbackSelectionChanged.ifAvailable();
    } catch {
      // Haptics are optional and should never block the action.
    }
  },
};
